import { render, staticRenderFns } from "./BaseCarouselItem.vue?vue&type=template&id=30f7a266&scoped=true&"
import script from "./BaseCarouselItem.vue?vue&type=script&lang=ts&"
export * from "./BaseCarouselItem.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCarouselItem.vue?vue&type=style&index=0&id=30f7a266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f7a266",
  null
  
)

export default component.exports